import { useEffect, useMemo, useState } from "react";
import { Box, Button, Center, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { useGetAllCicoTransferQuery, useGetCicoFiatAccountsQuery, useInitiateTransferMutation } from "apis";
import { AbstractModal, InputLabel, Select } from "components";
import ls from "utils/secureStorage";
import configs from "config";
import { ICicoQuote } from "interfaces";
import { CloseNewSVG } from "assets";
import { Pay } from "pages";
import CryptoTransferForm from "./CryptoTransferForm";
import { useDispatch, useSelector } from "react-redux";
import { selectForm, setRecipientAddress } from "store/slices";

interface IProps {
  handleTabChange: (index: number) => void;
  tabChange: (index: number) => void;
}
const InitiateCicoTransfer = ({ handleTabChange, tabChange }: IProps) => {
  const toast = useToast();
  const cicoType = ls.get(configs.CICO_TYPE);
  const quoteId = useMemo(() => ls.get(configs.CICO_QUOTE_ID) as string, []);
  const cicoToken = ls.get(configs.CICO_TOKEN_KEY);

  const { data, isLoading: fiatAcctLoading } = useGetCicoFiatAccountsQuery(null, {
    skip: cicoToken ? false : true,
  });
  const [_initiateTransfer, { isLoading }] = useInitiateTransferMutation();

  const [fiatAccountId, setFiatAccountId] = useState("");

  const transferType = useMemo(() => ls.get(configs.CICO_TYPE) as ICicoQuote["type"], []);

  const [transferId, setTransferId] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { refetch } = useGetAllCicoTransferQuery({
    limit: 5,
    page: 1,
  });

  const dispatch = useDispatch();
  const { recipientAddress, txHash } = useSelector(selectForm);

  const handleTransfer = async () => {
    try {
      const response = await _initiateTransfer({
        type: transferType,
        fiatAccountId,
        quoteId,
      }).unwrap();

      refetch();

      if (response) {
        onOpen();

        toast({
          position: "bottom-right",
          title: "Success",
          description: "Transfer initiated sucessfull",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        if (cicoType === "in" && response) {
          setTransferId(response.transferId);
        }

        dispatch(setRecipientAddress(response.transferAddress));
        // handleTabChange(1);
      }

      // response?.userActionDetails?.url && window.open(response.userActionDetails.url);
    } catch (error: any) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: error.data.error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const isDisabled = useMemo(() => !fiatAccountId || !quoteId, [fiatAccountId, quoteId]);

  const handleNavigate = () => {
    tabChange(2);
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    txHash && handleTabChange(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txHash]);

  // const walletBalance = ls.get("cico_balance");

  // const checkTransfer = useMemo(() => {
  //   return cicoType === "out" && Number(walletBalance) < Number(selectedCoinAmount);
  // }, [cicoType, selectedCoinAmount, walletBalance]);

  // console.log(checkTransfer, "check transfer");

  return (
    <>
      {!fiatAcctLoading && (
        <Box>
          {data && Object.values(data).length === 0 ? (
            <Box textAlign="center">
              You have no fiat account, add it{" "}
              <Text as="span" color="default.primary" textDecor="underline" onClick={handleNavigate} cursor="pointer">
                here
              </Text>
            </Box>
          ) : (
            <>
              <InputLabel htmlFor="fiatAccountId">Select Account</InputLabel>
              <Select id="fiatAccountId" onChange={(e) => setFiatAccountId(e.target.value)}>
                <option>Select Bank</option>
                {data?.BankAccount?.map(({ accountName, fiatAccountId }) => (
                  <option key={fiatAccountId} value={fiatAccountId}>
                    {accountName}
                  </option>
                ))}
              </Select>

              <Button
                minW={{ base: "100%", "2sm": "400px" }}
                mt="32px"
                onClick={handleTransfer}
                isLoading={isLoading}
                isDisabled={isDisabled}
              >
                Transfer
              </Button>

              {/* {checkTransfer && (
              <Text mt="24px" fontSize="14px" fontWeight="600" color="#fd774f">
                The wallet balance is lower than the amount you entered
              </Text>
            )} */}
            </>
          )}
        </Box>
      )}

      {transferId && cicoType === "in" && (
        <AbstractModal
          isOpen={isOpen}
          onClose={handleClose}
          closeOnOverlayClick={true}
          _content={{
            maxW: { base: "820px", md: "820px" },
            borderRadius: "20px",
            padding: "0",
            height: "90vh",
          }}
        >
          <Center justifyContent="right" onClick={handleClose} cursor="pointer" borderRadius="20px" padding="12px 20px 0">
            <CloseNewSVG />
          </Center>

          <Box mt="0">
            <Pay payId={transferId} removeHeader onClose={handleClose} />
          </Box>
        </AbstractModal>
      )}

      {recipientAddress && cicoType === "out" && <CryptoTransferForm initialRecipientAddress={recipientAddress} />}
    </>
  );
};

export default InitiateCicoTransfer;
